module.exports = __webpack_public_path__ + "files/6ebda15b3bf32acc082cfe8f8eafd81f.png";